import { API_BASE, request } from './api-client';
import type { AdminUserEntitlementView, PublishTransactionRow } from '../types';

const base = (userId: string) => `${API_BASE}/admin/users-mgmt/${userId}`;

export function getEntitlement(userId: string) {
  return request<AdminUserEntitlementView>(`${base(userId)}/entitlements`);
}

export function listPublishHistory(userId: string) {
  return request<PublishTransactionRow[]>(`${base(userId)}/publish-history`);
}

export function grantCredits(userId: string, input: { amount: number; reason?: string }) {
  return request<{ publishCredits: number }>(`${base(userId)}/credits/grant`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function revokeCredits(userId: string, input: { amount: number; reason?: string }) {
  return request<{ publishCredits: number }>(`${base(userId)}/credits/revoke`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
